import {Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, Output, SimpleChanges, ViewChild} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {A11yModule} from '@angular/cdk/a11y';
import {MonitoradorPedidos} from '../../fidelidade/MonitoradorPedidos';
import {CanalVenda, listeCanaisVenda, SituacaoCanalVenda} from './canais-venda.model';

@Component({
  selector: 'app-canais-venda', standalone: true,
  imports: [CommonModule, RouterModule, A11yModule],
  templateUrl: './canais-venda.component.html', styleUrls: ['./canais-venda.component.scss']
})
export class CanaisVendaComponent implements OnChanges {
  @Input() empresa: any = {};
  @Output() onAbrir = new EventEmitter<void>();
  @Output() onIntegracao = new EventEmitter<{tipo: 'keeta' | '99food'; loja: any; abrir: boolean}>();
  @ViewChild('gatilho') gatilho: ElementRef<HTMLButtonElement>;
  aberto = false;
  atualizando = false;
  topo = 80;
  esquerda = 12;
  largura = 840;
  readonly titulos: Record<SituacaoCanalVenda, string> = {
    aberta: 'Loja aberta', fechada: 'Loja fechada', desativada: 'Integração desativada',
    'sem-comunicacao': 'Sem comunicação', desconhecida: 'Status desconhecido'
  };

  constructor(public monitor: MonitoradorPedidos, private host: ElementRef<HTMLElement>) {}

  get canais(): CanalVenda[] { return listeCanaisVenda(this.empresa, this.monitor); }
  get abertas(): number { return this.canais.filter(canal => canal.situacao === 'aberta').length; }
  identifiqueCanal(indice: number, canal: CanalVenda): string { return `${canal.tipo}:${canal.loja.id ?? indice}`; }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.empresa?.previousValue?.id !== changes.empresa?.currentValue?.id) this.fechar(false);
  }

  alternar(): void {
    if (this.aberto) { this.fechar(); return; }
    this.onAbrir.emit();
    this.posicionar();
    this.aberto = true;
  }

  @HostListener('window:resize') posicionar(): void {
    if (!this.gatilho) return;
    const retangulo = this.gatilho.nativeElement.getBoundingClientRect();
    this.largura = Math.min(840, window.innerWidth - 24);
    this.esquerda = Math.max(12, Math.min(retangulo.left + retangulo.width / 2 - this.largura / 2,
      window.innerWidth - this.largura - 12));
    this.topo = retangulo.bottom + 12;
  }

  fechar(restaurarFoco = true): void {
    const estavaAberto = this.aberto;
    this.aberto = false;
    if (estavaAberto && restaurarFoco) this.gatilho.nativeElement.focus();
  }

  @HostListener('document:click', ['$event']) cliqueFora(evento: MouseEvent): void {
    if (!this.host.nativeElement.contains(evento.target as Node)) this.fechar(false);
  }

  teclado(evento: KeyboardEvent): void {
    if (evento.key !== 'Escape') return;
    evento.preventDefault();
    evento.stopPropagation();
    this.fechar();
  }

  alterar(canal: CanalVenda): void {
    if (!canal.controlavel || canal.loja.processando || (canal.tipo !== 'keeta' && canal.tipo !== '99food')) return;
    this.onIntegracao.emit({tipo: canal.tipo, loja: canal.loja, abrir: canal.situacao === 'fechada'});
  }

  async atualizar(): Promise<void> {
    if (this.atualizando) return;
    this.atualizando = true;
    try {
      const tipos = new Set(this.canais.map(canal => canal.tipo));
      await Promise.all([
        tipos.has('ifood') && this.monitor.autalizeStatusIfood(),
        tipos.has('99food') && this.monitor.autalizeStatus99Food(),
        tipos.has('keeta') && this.monitor.autalizeStatusKeeta(),
        tipos.has('opendelivery') && this.monitor.atualizeStatusOpenDelivery()
      ]);
    } finally { this.atualizando = false; }
  }
}
